import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GroupsGeographyDataRequest extends BaseServiceRequest {
    constructor() {
        super();
        super.addRequestUri("geography.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GROUPS;
    }

    getMessageName() {
        return "GroupsGeographyList";
    }
}

export default GroupsGeographyDataRequest;
